import React, {useState} from "react";
import {RegisterAPI, VerificationCodeAPI} from "../../services";
import {ValidateField} from "../../components/utils/validation";
import ConfirmCode from "../../components/features/ConfirmCode";
import {Link, Navigate} from 'react-router-dom';
import { LanguageLoader } from '../../assets/languages';
import { useSelector } from "react-redux";

const Register = () =>
{
	const language_config = localStorage.getItem('language') ? localStorage.getItem('language') : 'fa_IR';
	const language = LanguageLoader(language_config);
	const [step, SetStep] = useState(1);
	const [firstName, SetFirstName] = useState('');
	const [lastName, SetLastName] = useState('');
	const [email, SetEmail] = useState('');
	const [phoneNumber, SetPhoneNumber] = useState('');
	const [nationalCode, SetNationalCode] = useState('');
	const [password, SetPassword] = useState('');
	const [encryptedOTP, SetEncryptedOTP] = useState('');
	const registration = localStorage.getItem('registration');
	const notifyBy = localStorage.getItem('notifyby');
	const loginSettings = useSelector((state) => state.loginSettings);
	const SendRegistrationCode = async () =>
	{
		try {
			const data = {
				email: email,
				phone_number: phoneNumber,
				national_code: nationalCode,
				first_name: firstName,
				last_name: lastName,
			};
			const APIResponse = await VerificationCodeAPI(data);
			if (APIResponse.sent && APIResponse.encrypted_code.length)
			{
				SetEncryptedOTP(APIResponse.encrypted_code);
				SetStep(step + 1);
			}
		} catch(ex) {}
	}

	const RegisterUser = async () =>
	{
		try
		{
			if(encryptedOTP.length)
			{
				const data = {
					first_name: firstName,
					last_name: lastName,
					national_code: nationalCode,
					email: email,
					phone_number: phoneNumber,
					password: password,
				};
				const APIResponse = await RegisterAPI(data);
				if (APIResponse.token.length)
				{
					localStorage.setItem("token", APIResponse.token);
					window.location.replace('/');
				}
			}
		}
		catch (ex) {}
	}

	return (
		<React.Fragment>
			<h2 className="text-secondaryFont text-center mt-14 absolute inset-x-0 -top-40" style={{color: loginSettings.color}}>{language.AUTHENTICATION.REGISTER_ACCOUNT}</h2>
			{!registration ? <Navigate to='/login'/> :
			step === 1 ?
				<React.Fragment>
					<input className='mb-3' type="text" placeholder={language.AUTHENTICATION.FIRST_NAME+' *'} onChange={(e) => SetFirstName(e.target.value)} value={firstName}/>
					<input className='mb-3' type="text" placeholder={language.AUTHENTICATION.LAST_NAME+' *'} onChange={(e) => SetLastName(e.target.value)}/>
					<input className='mb-3 ltr' type="text" placeholder={language.AUTHENTICATION.EMAIL+(notifyBy === 'Email' ? ' *' : '')} onChange={(e) => SetEmail(e.target.value)}/>
					<input className='mb-3' type="text" placeholder={language.AUTHENTICATION.CELL_PHONE+(notifyBy === 'SMS' ? ' *' : '')} onChange={(e) => SetPhoneNumber(e.target.value)}/>
					{loginSettings.kyc &&( <input className="mb-3" type="text" placeholder={language.AUTHENTICATION.NATIONAL_CODE+' *'} onChange={(e) => SetNationalCode(e.target.value)} />)}
					<input className='mb-3' type="password" placeholder={language.AUTHENTICATION.PASSWORD+' *'} onChange={(e) => SetPassword(e.target.value)}/>
					<div className="mt-5 text-center">
						<button className="btn-primary w-full" onClick={SendRegistrationCode} style={{background: loginSettings.color, borderColor: loginSettings.color}}><span style={{color: loginSettings.background}}>{language.AUTHENTICATION.SIGN_UP}</span></button>
						<Link to="/login"><button className="btn-primary w-full secondary" style={{borderColor: loginSettings.color, color: loginSettings.color}}><span style={{color: loginSettings.background}}>{language.AUTHENTICATION.LOGIN}</span></button></Link>
					</div>
				</React.Fragment>
			: step === 2 ? 
				<ConfirmCode callback={RegisterUser} encryptedOTP={encryptedOTP} prevStep={(() => SetStep(step - 1))}></ConfirmCode>
			: null}
		</React.Fragment>
	)
}

export default Register;
